import app from './de-DE.json'
import countries from './countries'

const DE = {
  ...app,
  ...countries
}

export default DE



// WEBPACK FOOTER //
// ./src/i18n/de/index.js